import { Icon, IconProps } from '@chakra-ui/react'

export default function NewTrashDeleteIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#495057'}
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M15.543 21.004H8.457a2.251 2.251 0 01-2.244-2.079L5.247 6.373h13.506l-.966 12.552a2.25 2.25 0 01-2.244 2.079v0z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.003 6.373H3.997"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M9.187 2.997h5.627c.621 0 1.125.503 1.125 1.125v2.251H8.061V4.122a1.125 1.125 0 011.126-1.125z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 17.002h4"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
